import dotenv from 'dotenv';
dotenv.config();

let env = {
    dev: {
        endpoint: 'https://d3te8mcrr2n87h.cloudfront.net/api',
        apikey: 'fRVoroghxC1PCuNW3NQiEcU24XiIH4I5UlyLiOm3'
    },
    stg: {
        endpoint: 'https://stg-dakoku.sonymusic.co.jp/api',
        apikey: 'ZylZqyBQ1D7FdIueKbRDt5oIEVYLOBiBaT8RSWL9'
    },
    prd: {
        endpoint: 'https://dakoku.sonymusic.co.jp/api',
        apikey: 'cbNGZLBt1gj1crqfunI45VJWhPo7j88aFiHupgs2'
    }
};

export default env = env[process.env.REACT_APP_ENV];



// WEBPACK FOOTER //
// ./src/config.js